@if (timesheet.torAndRosterFinished$ | async) {
  <div class="mb-2 mt-4 flex w-full items-center justify-start gap-4 px-4">
    <div class="shrink-0">
      <wedate-input [dateHandler]="timesheet.weDate" [hasIncrementors]="true" (weDateChanged)="handleWeDateChanged()" />
    </div>
    <span class="mr-auto text-xl/none">{{ approvingName }}'s Page</span>
    <div class="flex shrink-0 items-center justify-end gap-4">
      <span>{{ timesheet.timesheetStatus.description }}</span>
      <button
        mat-raised-button
        color="warn"
        [disabled]="!timesheet.timesheetStatus.shouldPermitPayrollApproval"
        (click)="approve()"
      >
        Approve
      </button>
    </div>
  </div>
  <div class="flex justify-start gap-4">
    <div class="mt-12 flex h-[50vh] flex-col justify-between border-r border-[lightgray] pr-2">
      <tabs layout="col" class="w-44" [tabs]="sectionTabs" (tabChanged)="changeTab($event)" />
      <div class="flex flex-col gap-2 pl-2">
        @if (active !== 'Production') {
          <span class="border-b border-[lightgray] text-center text-xl leading-6">Toolbar</span>
        }
        @if (active === 'Employees') {
          <button mat-raised-button (click)="addEmployee()">
            <mat-icon>person</mat-icon>
            Add Employee +
          </button>
        } @else if (active === 'Equipment') {
          <button mat-raised-button (click)="addEquipment()">
            <mat-icon>local_shipping</mat-icon>
            Add Equipment +
          </button>
        }
      </div>
    </div>
    <div class="flex w-[55%] min-w-[600px] flex-col justify-start">
      <tabs
        layout="row"
        tabWidth="100px"
        [tabs]="costCenters"
        [shouldSeparateFinal]="true"
        [active]="costCenters.length - 1"
        (tabChanged)="handleCostCenterTabChange($event)"
      />
      <div>
        @if (active === 'Employees') {
          <table-like-layout
            configPath="payrollConfig"
            valuePath="payrollGrid"
            [config]="employeeConfig"
            [values]="employees"
            [omitActivityCodesFromTotalRow]="omitActivityCodesFromTotalRow"
            (numberBoxClicked)="changeDetailPayne($event)"
            (headerClicked)="handleHeaderClick($event)"
            (textClicked)="handleTextClick($event)"
          />
        } @else if (active === 'Equipment') {
          <table-like-layout
            valuePath="payrollGrid"
            [config]="equipmentConfig"
            [values]="equipment"
            (numberBoxClicked)="changeDetailPayne($event)"
            (textClicked)="handleTextClick($event)"
          />
        } @else if (active === 'Production') {
          <table-like-layout
            valuePath="payrollGrid"
            [config]="productionConfig"
            [values]="production"
            (numberBoxClicked)="changeDetailPayne($event)"
          />
          <table-like-layout
            valuePath="payrollGrid"
            columnLimit="4"
            [config]="productionTextConfig"
            [values]="productionText"
            [shouldHideTotal]="true"
            [shouldHideHeaders]="true"
            (numberBoxClicked)="showTextDetailPayne($event)"
          />
        }
      </div>
    </div>
    <detail-payne class="w-2/5 min-w-[500px]" />
  </div>
} @else {
  <div class="section-loader-wrapper">
    <mat-spinner />
  </div>
}
